import { TaskTypesEnum } from '@/bundles/Tasks/enums/TaskTypesEnum';

const dictionary: Record<TaskTypesEnum, string> = {
  [TaskTypesEnum.call]: 'mdi-phone-classic',
  [TaskTypesEnum.email]: 'mdi-at',
  [TaskTypesEnum.todo]: 'mdi-format-list-checks',
  [TaskTypesEnum.meeting]: 'mdi-calendar-outline',
};

export const getTaskIconByType = (type: TaskTypesEnum): string => {
  return dictionary[type];
}
